export default __webpack_public_path__ + "static/media/whale.bbb54b90.svg";